import { createContext, useRef, ComponentType } from 'react';

import { ILandingPageLayoutContext } from './types';

export const defaultValue = { headerRef: null };

const LandingPageLayoutContext = createContext<ILandingPageLayoutContext>(defaultValue);

export const withLandingPageLayoutContext = (Component: ComponentType) => (props: any) => {
  const headerRef = useRef(null);

  return (
    <LandingPageLayoutContext.Provider value={{ headerRef }}>
      <Component {...props} />
    </LandingPageLayoutContext.Provider>
  );
};

export default LandingPageLayoutContext;
